import '../../api/Admin/methods';
import '../../api/Admin/server/publications';

import '../../api/App/server/publications';
import '../../api/App/methods';

import '../../api/Layers/methods';
import '../../api/Layers/server/publications';

import '../../api/Maps/methods';
import '../../api/Maps/server/publications';

import '../../api/Styles/methods';
import '../../api/Styles/server/publications';

import '../../api/MapServerElements/methods';
import '../../api/MapServerElements/server/publications';

import '../../api/Connectors/methods';
import '../../api/Connectors/server/publications';

import '../../api/Sources/methods';
import '../../api/Sources/server/publications';

import '../../api/Tasks/methods';
import '../../api/Tasks/server/publications';

import '../../api/Graphics/methods';
import '../../api/Graphics/server/publications';

import '../../api/Users/server/methods';
import '../../api/Users/server/publications';

import '../../api/Atlas/methods';
import '../../api/Atlas/server/publications';

import '../../api/OAuth/server/methods';

import '../../api/TelemetryConnections/server/publications';
import '../../api/TelemetryConnections/methods';

import '../../api/Videos/server/publications';
import '../../api/Videos/methods';

import '../../api/Annotations/server/publications';
import '../../api/Annotations/methods';

import '../../api/AnnotationTemplates/methods';
import '../../api/AnnotationTemplates/server/publications';

import '../../api/Projects/server/publications';
import '../../api/Projects/methods';

import '../../api/Profiles/server/publications';
import '../../api/Profiles/methods';

import '../../api/UserControl/server/publications';
// import '../../api/UserControl/methods';

import '../../api/TrackingAnnotations/methods';
import '../../api/TrackingAnnotations/server/publications';

import '../../api/ConfigurationsConnectors/server/publications';
import '../../api/ConfigurationsConnectors/methods';

// TODO: soon to be @deprecated
// import '../../api/EsriAPI/server/methods';
